export const NotificacionesTabla = {
  notify_1:"Inicio sesión",
  notify_2:"Cerro sesión",
  notify_3:"Acepto el servicio",
  notify_4:"Cancelo el servicio asignado",
  notify_5:"Se le agoto el tiempo de respuesta: servicio cancelado",
  notify_6:"Cancelo servicio en curso asignado",
  notify_7:"Ha llegado al lugar de carga",
  notify_8:"Ha llegado a su destino",
  notify_panic:"Presiono el botón de pánico"
};



// WEBPACK FOOTER //
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/components/Config/notify_msj.config.ts